import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useAnalysisPageStyles = makeStyles((theme: Theme) => ({
  root: {
    background: theme.palette.background.paper,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: `0 ${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)}`,
    // 0 24px 36px 24px
    width: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1), // 12px
    alignItems: 'flex-start',
    width: '100%',
  },
  topHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  description: {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
    marginTop: 0,
    marginBottom: 0,
  },
  selectContainer: {
    width: '100%',
    marginTop: theme.spacing(6.67), // 80px
    marginBottom: 0,
    gap: theme.spacing(2.67), // 32px between label and dropdown
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  button: {
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(0.83)} ${theme.spacing(1)}`, // 10px 12px
    marginTop: theme.spacing(2.67), // 32px
    marginBottom: 0,
  },
  linearProgress: {
    marginTop: theme.spacing(2.67), // 32x
    width: '100%',
  },
}));

export default useAnalysisPageStyles;
